import React, {useEffect, useRef, useState} from "react";
import {connect} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {CButton, CCol, CForm, CFormLabel, CRow} from "@coreui/react";
import * as o2Api from "../../../../../api/api";
import numeral from "numeral";
import {Loading} from "../../../../../components/common";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import * as formatter from "../../../../../config/formatter";
import {gridColumnSum} from "../../../../../config/common";

const PopupSaleSt = () => {
	const gridRef = useRef();
	const [params] = useSearchParams();
	const [loading, setLoading] = useState(false);
	const [saleHd, setSaleHd] = useState([{
		saleAmt: 0, payAmt: 0, dcAmt: 0, vatAmt: 0, netAmt: 0, serviceAmt: 0
	}]);
	const [saleDt, setSaleDt] = useState([]);
	const [saleSt, setSaleSt] = useState([{
		payAmt: 0, payDiv: "10"
	}]);
	const queryList = [...params];
	const seq = queryList[0][1];
	const type = queryList[1][1];

	const defaultColDef = {
		width: 100,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true
	};

	const [columnDefs] = useState([
		{headerName: "No", maxWidth: 50, valueGetter: "node.rowIndex + 1", cellClass: "static-cell"},
		{field: "tradeTypeNm", headerName: "승인구분", maxWidth: 80},
		{field: "cardNo", headerName: (type === 'cash' ? "인증번호" : "카드번호"), minWidth: 120},
		{field: "cardExp", headerName: "유효기간", maxWidth: 80, cellClass: "static-cell", hide: (type === 'cash')},
		{
			field: "cardInstal",
			headerName: "할부",
			maxWidth: 60,
			hide: (type === 'cash'),
			valueFormatter: formatter.currencyFormatter,
			cellClass: "static-cell"
		},
		{field: "payAmt", headerName: "승인금액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{
			field: "appTime",
			headerName: "승인일자",
			valueFormatter: (e) => formatter.timeFormatter(e, "YYMMDDHHmm", "20YY-MM-DD"),
			cellClass: "static-cell"
		},
		{
			field: "appTime",
			headerName: "승인시각",
			valueFormatter: (e) => formatter.timeFormatter(e, "YYMMDDHHmm", "HH:mm:ss"),
			cellClass: "static-cell"
		},
		{field: "appNo", headerName: "승인번호", cellClass: "static-cell"},
		{field: "ccmpName", headerName: "발급사", cellClass: "static-cell", hide: (type === 'cash')},
		{field: "bcmpName", headerName: "매입사", cellClass: "static-cell", hide: (type === 'cash')},
		{field: "dcAmt", headerName: "원거래승인일자"},
		{field: "dcAmt", headerName: "원거래승인번호"},
	]);

	const [totalRowData] = useState([
		{no: 0, storeNm: "합계"}
	])

	const createFooterData = (data) => {
		const api = gridRef.current.api;
		const result = [];
		result.push({
			storeNm: "합계",
			payAmt: gridColumnSum(data, 'payAmt'),
		});
		api.setPinnedBottomRowData(result);
	};

	useEffect(() => {
		getSaleSt(seq);
	}, []);

	const getSaleSt = (seq) => {
		setLoading(true);
		o2Api.getDetailCurrentDaySaleSt(seq).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			console.log("### response :: ", responseBody);
			if (responseCode === "200") {
				setLoading(false);

				// parameter type 에 따라 현금/카드로 구분한다
				let filterData;
				if (type === 'cash') {
					filterData = responseBody.filter(item => item.payDiv === '10');
				}
				else if (type === 'card') {
					filterData = responseBody.filter(item => item.payDiv === '20');
				}
				setSaleSt(filterData);
				createFooterData(filterData);
			} else {
				setLoading(false);
			}
		});
	}

	return (
		<>
			<div style={{padding: 16}}>
				{loading ? <Loading/> : null}
				<div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#13319b"}}>
                    <span
						style={{
							color: 'white',
							fontWeight: 600
						}}>매출일자 : [{saleSt[0].saleDt}] 포스번호 [{saleSt[0].posCd}] 영수증번호 [{saleSt[0].billNo}]</span>
				</div>
				<div className="ag-theme-alpine" style={{width: "100%", height: 250, marginTop: 10}}>
					<AgGridReact
						ref={gridRef}
						rowSelection={"single"}
						headerHeight={30}
						rowHeight={30}
						rowData={saleSt}
						animateRows={true}
						pinnedBottomRowData={totalRowData}
						defaultColDef={defaultColDef}
						columnDefs={columnDefs}>
					</AgGridReact>
				</div>
			</div>
		</>
	)
}

export default connect(null, null)(PopupSaleSt);
